import React from 'react';

const UnitDishwasher = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M24.375 4.6875H5.625C5.10723 4.6875 4.6875 5.10723 4.6875 5.625V24.375C4.6875 24.8928 5.10723 25.3125 5.625 25.3125H24.375C24.8928 25.3125 25.3125 24.8928 25.3125 24.375V5.625C25.3125 5.10723 24.8928 4.6875 24.375 4.6875Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.84375 7.5625C10.5859 7.5625 11.1875 8.16412 11.1875 8.90625C11.1875 9.64838 10.5859 10.25 9.84375 10.25C9.10162 10.25 8.5 9.64838 8.5 8.90625C8.5 8.16412 9.10162 7.5625 9.84375 7.5625Z"
        fill="#343330"
        stroke="CurrentColor"
        strokeWidth="0.125"
      />
      <path
        d="M15 10.3125C15.7767 10.3125 16.4062 9.6829 16.4062 8.90625C16.4062 8.1296 15.7767 7.5 15 7.5C14.2233 7.5 13.5938 8.1296 13.5938 8.90625C13.5938 9.6829 14.2233 10.3125 15 10.3125Z"
        fill="#343330"
      />
      <path
        d="M20.1562 10.3125C20.9329 10.3125 21.5625 9.6829 21.5625 8.90625C21.5625 8.1296 20.9329 7.5 20.1562 7.5C19.3796 7.5 18.75 8.1296 18.75 8.90625C18.75 9.6829 19.3796 10.3125 20.1562 10.3125Z"
        fill="#343330"
      />
      <path
        d="M21.5625 13.125H8.4375V21.5625H21.5625V13.125Z"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnitDishwasher;
